import { css, cva } from '@/styled-system/css';

// Design Specs: https://www.figma.com/file/2UlxeTUdKRMOHjl0h3rOg1/Starter-File-Multi-Step-Forms-AKA-Wizards?node-id=119%3A24517

export const wizardFormStyles = css.raw({
  flexGrow: 2,
});

export const wizardHeadingStyles = css.raw({
  display: 'block',
  marginBottom: '400',
});

export const wizardParagraphStyles = css.raw({
  display: 'block',
  marginBottom: '600',
});

export const wizardFormSectionContainerStyles = cva({
  base: {
    marginBottom: '800',

    '&:last-child': {
      marginBottom: '600',
    },
  },
  variants: {
    isInMultiplexListingFlow: {
      true: {
        width: '100%',
        maxWidth: '100%',
      },
      false: {
        maxWidth: { xxl: '656px' },
      },
    },
  },
  defaultVariants: {
    isInMultiplexListingFlow: false,
  },
});

const CONTENT_MAX_WIDTH_WITH_TIP = '728px';
const TIP_CARD_WIDTH = '328px';

export const wizardFlexContainerStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: {
    base: 'minmax(0, 1fr)',
    xl: `minmax(0, ${CONTENT_MAX_WIDTH_WITH_TIP}) ${TIP_CARD_WIDTH}`,
  },
  columnGap: 'layout.vast.looser',
  rowGap: { base: 'layout.loose', md: 'layout.looser' },
  alignItems: 'start',
});

export const wizardLabeledControlStyles = css.raw({
  minWidth: '50%',
});
